export default __webpack_public_path__ + "static/building-5010-88a25ed1fd06cc20281b4eaa1ecb8d9d.jpeg";